module.exports = __webpack_public_path__ + "static/img/par2.a9977806.png";